// extracted by mini-css-extract-plugin
module.exports = {"container":"SettingsMyPosTerminals_container__2ZB-E","container-ltr":"SettingsMyPosTerminals_container-ltr__Kh-x-","button":"SettingsMyPosTerminals_button__14I6Q"};